import {BarChartHorizontal} from "./plotly/BarChartHorizontal";
import {Typography, useTheme} from "@mui/material";
import {useMemo} from "react";
import {useOutletContext} from "react-router";
import {formatCurrency} from "../utils/formatters";
import {buildProfitDriversPanelChartData, getProfitDriversTotalImpact} from "../utils/profitDrivers";

export const ProfitDriversPanel = ({minimal = false, data}) => {
    const {navOptions, handleNavigate} = useOutletContext();
    const theme = useTheme();
    const dims = theme.dimensions;
    const panelTheme = theme.palette.contentPanel;
    const indicatorTheme = theme.palette.indicator;

    const profitData = useMemo(
        () => buildProfitDriversPanelChartData(data),
        [data]
    );

    const totalImpact = useMemo(
        () => getProfitDriversTotalImpact(data),
        [data]
    );

    const handleHeaderClick = () => {
        handleNavigate(navOptions.audit.subMenu.auditDrivers);
    };

    return (
        <div style={{
            ...panelTheme,
            marginTop: 30,
            padding: 10,
            width: !minimal ? dims.normalPanelWidth : dims.smallPanelWidth,
            height: dims.smallPanelHeight
        }}>
            <Typography
                variant="h5"
                display="inline"
                style={{marginLeft: 10, cursor: 'pointer'}}
                onClick={handleHeaderClick}
            >
                Profit Drivers
            </Typography>
            <Typography
                variant="h5"
                display="inline"
                style={{
                    marginRight: 10,
                    float: 'right',
                    color: totalImpact >= 0 ? indicatorTheme.green : indicatorTheme.red
                }}
            >
                {formatCurrency(totalImpact, true, true)}
            </Typography>
            <BarChartHorizontal title="Profit Drivers" data={profitData}/>
        </div>
    );
};
